import styled from 'styled-components';

export default styled.label`
  display: block;
`;



// WEBPACK FOOTER //
// ./app/styled-components/InputLabel.js